import { __ } from "@wordpress/i18n";
import { logoSVG } from "./logo";

class OrderList {
  constructor() {
    this.addPaymentLinkButtonOnSettings();
    this.addPaymentLinkButtonOnGateways();
    this.addPaymentLinkButtonOnOrders();
    const orders = document.querySelectorAll(
      ".type-shop_order.status-wc-pending",
    );
    if (orders) {
      this.addPaymentLinkButton(orders);
    }
  }

  addPaymentLinkButtonOnSettings() {
    const anchor = document.querySelector("#vindi-pagamentos-token");
    if (anchor) {
      const side = document.querySelector("#wvp-export-btn");
      this.createPaymentLinkButton(side, [
        "components-button",
        "woocommerce-save-button",
        "is-primary"
      ]);
    }
  }

  addPaymentLinkButtonOnGateways() {
    const gateways = ["billet", "credit", "pix", "bolepix", "transfer"];

    gateways.forEach((gateway) => {
      const anchor = document.querySelector(
        `#woocommerce_vindi-pagamentos-${gateway}_enabled`,
      );

      if (anchor && anchor.checked) {
        const side = document.querySelector("#mainform > .submit > button");
        this.createPaymentLinkButton(
          side,
          ["woocommerce-save-button", "is-secondary", "components-button"],
          { gateway: `vindi-pagamentos-${gateway}` },
        );
      }
    });
  }

  addPaymentLinkButtonOnOrders() {
    const postType = document.querySelector("input[name=post_type]");
    if (postType && postType.value === "shop_order") {
      const side = document.querySelector(".page-title-action");
      if (side) {
        const button = document.createElement("a");
        button.setAttribute("target", "_blank");
        button.setAttribute("id", "wvp-payment-link-btn");
        button.setAttribute(
          "href",
          `${location.origin}/wp-admin/post-new.php?post_type=shop_order&vindi-payment-link=true`,
        );
        button.classList.add("button-primary", "page-title-action");
        button.innerText = "Gerar Link de Pagamento";
        side.after(button);
      }
    }
  }

  createPaymentLinkButton(side, classes = [], params = {}) {
    if (side) {
      const button = document.createElement("a");
      button.setAttribute("target", "_blank");
      button.setAttribute("id", "wvp-payment-link-btn");

      button.setAttribute(
        "href",
        `${location.origin}/wp-admin/post-new.php?${this.getUrlParams({
          post_type: "shop_order",
          "vindi-payment-link": true,
          ...params,
        })}`,
      );

      button.classList.add(...classes);
      button.innerText = "Gerar Link de Pagamento";

      side.after(button);
    }
  }

  getUrlParams(params) {
    const searchParams = {};

    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key) && params[key]) {
        searchParams[key] = params[key];
      }
    }

    return new URLSearchParams(searchParams).toString();
  }

  addPaymentLinkButton(orders) {
    orders.forEach((order) => {
      const link = order.querySelector("a.order-view");
      const paymentLinkColumn = order.querySelector("td.vindi_payment_link");

      if (!paymentLinkColumn) {
        return;
      }

      const button = document.createElement("a");
      button.innerHTML = logoSVG();

      const span = document.createElement("span");
      span.innerText = __("Link de Pagamento", "vindi-pagamentos");
      button.appendChild(span);

      button.classList.add("vindi-payment-link-button");
      button.setAttribute(
        "href",
        `${link.getAttribute("href")}&vindi-payment-link=true`,
      );

      paymentLinkColumn.innerHTML = '';
      paymentLinkColumn.appendChild(button);
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new OrderList();
});
